import { v4 as uuid } from 'uuid';
import * as yup from 'yup';

import { convertTo62, convertToUUID } from 'uuid-encoding';

import { StringTypeBase } from '../../types/baseTypes/StringTypeBase';
import { TypeContextEnum } from '../../types/properties/TypeContextEnum';
import Types from '../Types';
import { TYPE_GROUP_OTHER } from '../constants';

/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use UUIDType from application-types instead.
 */
export class UUIDType extends StringTypeBase {
  group = TYPE_GROUP_OTHER;

  name = 'UUID';

  friendlyName = 'Unique ID';

  contexts = [
    TypeContextEnum.Block,
    TypeContextEnum.Content,
    TypeContextEnum.Properties,
  ];

  get example() {
    return convertTo62(uuid());
  }

  get default(): any {
    return convertTo62(uuid());
  }

  buildSchema() {
    return yup.string().nullable();
  }

  /**
   * todo: disable UUID validation for now

   .test(
   'is-uuid',
   '${path} is not a valid UUID',
   value =>
   value &&
   (value.length === UUID.length || value.length === UUID_BASE62.length)
   )
   */
  serialize = (value: any) => {
    if (!value) {
      return value;
    }

    return convertTo62(value);
  };

  parseValue = (value: any) => {
    if (!value) {
      return value;
    }

    return convertToUUID(value);
  };
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use UUID from application-types instead.
 */
const definition = new UUIDType();

Types.addBaseType(definition);
export default definition;
